var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendarBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_7305_14642)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7305_14642",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7305_14642",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7305_14642",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADOklEQVR4nO3dv04UQRwH8O/MnlioCdDd7pKcR5RHoOKiwgOQmEAllTwCDyGV0cJCK6m0slcS/hQ8gyH8kTvuYmLARC1E7sZCTAzuzjHDXn7s7vdTzu7OTPbL3MwNl12AiIiIqIxUVhVV43GTVN5p7WTWxiBJ9V8PsnLqjwEIYwDCGIAwBiDMaYYPw/qM0WoOQAMwMaBuDKhfV5T5AagWgE3VM2/a7d0Pl63xQgFEUf1uT+EloBqXbbBg1gOYxVZrd9u3gr4BVMfuNGB67wCM+DZScMdQerbT3N7wudgaQBjenjBab4E3v5/jAGbSZyTYJ2GtX4A3/yJGusArnwtTAwjD+owB7vv3qWxUI4rq065XVdIOGK3mUw79VMDSUKW7sr+///VvYRn2gmq12vDJabBggGUA18+f21NqHsCqS7upAQBIXPEoYKnd2nnu0khRnP3BPavGdQWop/+foaZc67TNAdWkwqFKd8W1kaK5pk9fJx8xkWtdtgBuJRX++7FTVgcHB8cphxLvmQ23IoQxAGG2SdhJXlY7aaT6zxEgjAEIYwDCGIAwBiDMeRWUtmdCfjgChDEAYQxAGAMQxgCEOa+C8r7nk5WsVoMcAcIYgDAGIIwBCGMAwjL7j5gr198RXbXzs8IRIIwBCGMAwhiAMAYgLHWGz/uvnQctq/vDESCMAQhjAMIYgDAGICyzvaCrtlfDvSC6EAYgjAEIYwDCGIAw7gV54l5QQTAAYQxAGAMQxgCEFXYvKC84AoQxAGEMQBgDEMYAhIk9L2jQ5+cFR4AwBiDMFsC3pMJarTY8oL7kRhzHoymHEu+ZjS2AdlLhyWmw4NpI0XQx9Cj5iDp0rcs2CW8AmDhfaIDlMB5HRf9asTw/s5DiOB79c/PVk+QzjPMj7FNXFmdvy3jvWmGZaWNmDg93nZ4dbX9/QDy+aoAHl+tWaax3Wjv3XC+yroK6QeUxgC++PSoPdRTALPpcaQ3g86ePe1D6IYBSfda7UUdQ3Vnf98j0/R7QaW5vBDCTANZ8Gii4tQBmstPc2/StwOnrfRTVp3tKzcFgCgpjAG76NpxT32HQhMKmNuat64RLRERERERERETl9hucQ/oCDyziRAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarBlack);
export default __webpack_public_path__ + "static/media/icon-calendar-black.bea015550b4c7e69a1350de7ca10295a.svg";
export { ForwardRef as ReactComponent };